import React, { useEffect, useState } from 'react';

const Weighing = () => {
    return <p>Weighing</p>
}

export default Weighing;